import React from 'react';
import { App } from '../../App';





export class ImagePage extends React.Component {
    imgWidth = 648;
    imgHeight = 648;

    createImage(initials:string) {
        //Use "getElementById" method on document object to find the canvas element
        var canvas = document.getElementById('ImageCreator') as HTMLCanvasElement;
        //Call the getContext('2d') method and assign it to context object
        if (canvas) {
            var context = canvas.getContext('2d') as CanvasRenderingContext2D;
            if (context) {
                // context.font = 'bold 35pt Papyrus,Arial';
                // context.fillText('HTML5 Canvas', 100, 100);
                // VW-Blau füllen
                context.fillStyle = '#C6DFE7';
                context.fillRect(0, 0, this.imgWidth, this.imgHeight);
                // Intialen
                context.fillStyle = '#000000';
                context.font = `${this.imgHeight / 2}px VWAG TheSans`;
                //Textgröße
                let TextSize = context.measureText(initials);
                
                //mittig ausgerichtet 
                context.fillText(initials, (this.imgWidth - TextSize.width) / 2, (this.imgHeight + TextSize.actualBoundingBoxAscent) / 2);

            }
        }
    }
    componentDidMount() {
        this.createImage(App.instance.getInitials());
    }
    render() {

        return <><canvas id="ImageCreator" width={`${this.imgWidth}px`} height={`${this.imgWidth}px`}></canvas></>;
    }


}